export const ERROR_CODES = {
  notFound: "notfound",
  waitlistRequestFailed: "waitlistrequestfailed",
  waitlistUserNotFound: "waitlistusernotfound",
  waitlistUserNotOffboarded: "waitlistusernotoffboarded",
  wrongPassword: "wrongpassword",
  alreadyRegistered: "alreadyregistered",
};
